<template>
    <DCard>
        <DRow>
            <DCol>
                <DTable
                    :items="sanityChecksItems"
                    :fields="fields"
                >
                    <template #name="{item}">
                        <td>
                            <span
                                v-c-tooltip="item.description"
                                class="pointer-events"
                            >{{ item.name }}</span>
                        </td>
                    </template>
                    <template #status="{item}">
                        <td v-if="item.status">
                            <DTag
                                color="success"
                                :label="__('administrations.sanity_checks.table.passed')"
                            />
                        </td>
                        <td v-else>
                            <DTag
                                color="danger"
                                :label="__('administrations.sanity_checks.table.failed')"
                            />
                        </td>
                    </template>
                    <template #level="{item}">
                        <td v-if="item.level === 'warning'">
                            <DTag
                                color="warning"
                                :label="__('administrations.sanity_checks.table.warning')"
                            />
                        </td>
                        <td v-else>
                            <DTag
                                color="danger"
                                :label="__('administrations.sanity_checks.table.fatal')"
                            />
                        </td>
                    </template>
                    <template #affected_objects="{item}">
                        <td>
                            <DButton
                                v-if="item.affected_objects.length !== 0"
                                icon="eye"
                                mini
                                @click="showAffectedObjects(item)"
                            />
                            <DButton
                                v-if="item.affected_objects.length !== 0"
                                icon="file-download"
                                mini
                                :disabled="isInLoadingState"
                                @click="exportCsv(item)"
                            />
                        </td>
                    </template>
                </DTable>
                <DPagination
                    v-if="sanityChecks.last_page > 1"
                    :active-page="sanityChecks.current_page"
                    :pages="sanityChecks.last_page"
                    align="center"
                    @update:activePage="changePage"
                />
            </DCol>
        </DRow>
        <AffectedObjectsModal
            v-if="showAffectedObjectsModal"
            :show-modal="showAffectedObjectsModal"
            :sanity-check="sanityCheck"
            @close-modal="showAffectedObjectsModal = false; sanityCheck = null;"
            @update-affected-objects="refreshAffectedObjects"
        />
    </DCard>
</template>

<script>
import AffectedObjectsModal from '~@/Components/Administrations/SanityChecks/AffectedObjectsModal'

export default {
    name: 'SanityChecksIndex',
    components: { AffectedObjectsModal },
    props: {
        sanityChecks: {
            type: Object,
            default: () => { return {} }
        }
    },
    data () {
        return {
            fields: [
                { key: 'name', label: this.__('administrations.sanity_checks.table.name'), _style: { minWidth: '30%' } },
                { key: 'status', label: this.__('administrations.sanity_checks.table.status'), _style: { minWidth: '15%' } },
                { key: 'last_execution', label: this.__('administrations.sanity_checks.table.last_execution'), _style: { minWidth: '20%' } },
                { key: 'affected_objects', label: this.__('administrations.sanity_checks.table.affected_objects'), _style: { minWidth: '20%' } }
            ],
            showAffectedObjectsModal: false,
            sanityCheck: null,
            sanityChecksItems: this.sanityChecks.items
        }
    },
    methods: {
        changePage (page) {
            const query = {}

            if (page > 1) {
                query.page = page
            }

            this.$inertia.get(this.$route('administrations.sanity-checks.index'), query)
        },
        showAffectedObjects (item) {
            // We need to rely on index and get an item like that however CoreUI has a bug and they are ignoring it
            // https://github.com/coreui/coreui-vue/issues/237
            this.sanityCheck = item
            this.showAffectedObjectsModal = true
        },
        refreshAffectedObjects (item) {
            for (const sanityCheck in this.sanityChecksItems) {
                if (this.sanityChecksItems[sanityCheck].id === item.id) {
                    this.sanityChecksItems[sanityCheck] = item
                }
            }
        },
        exportCsv (item) {
            const link = document.createElement('a')
            link.href = this.$route('administrations.sanity-checks.download_csv_affected_objects', { sanity_check: item.id })
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    }
}
</script>

<style lang="scss" scoped>
.pointer-events {
    pointer-events: auto !important;
    cursor: default;
}
</style>
